export default __webpack_public_path__ + "static/media/short_notes.088f48d6.png";